const faqs = [
  {
    q: '韩漫平台真的完全免费吗？',
    a: '是的，韩漫平台上所有漫画资源永久免费向用户开放。无需购买会员、无需充值点数、无需任何形式的付费，打开即可畅读全部作品。我们通过广告和合作渠道维持运营，始终坚持以免费服务广大韩漫爱好者。',
  },
  {
    q: '更新速度怎么样？能和韩国同步吗？',
    a: '我们的翻译团队与韩国多家漫画平台保持紧密合作，大部分热门作品可实现韩网更新后30分钟至2小时内上线中文版。部分作品已实现与韩国原版平台同步更新，确保读者第一时间读到最新章节。',
  },
  {
    q: '手机和平板上可以看韩漫吗？',
    a: '完全可以！韩漫平台已全面适配手机、平板和电脑浏览器，无需下载任何App。只需在浏览器中打开网站，页面会根据您的设备屏幕自动优化排版，提供流畅的竖屏滚动阅读体验。建议使用Chrome或Safari浏览器以获得最佳效果。',
  },
  {
    q: '平台上的韩漫有正版授权吗？',
    a: '韩漫平台致力于为正版韩漫提供推广渠道，我们与多家韩国漫画平台和版权方建立了合作关系，获得授权的内容均标注了版权信息。我们也在持续拓展合作范围，为读者带来更多正版优质的韩漫作品。如有版权疑问，欢迎通过联系我们页面与我们沟通。',
  },
  {
    q: '如何推荐自己喜欢的韩漫作品？',
    a: '如果您有想看的韩漫作品尚未被平台收录，欢迎通过页面上方的"联系我们"板块提交推荐。只需填写作品名称和推荐理由，我们的内容团队会认真审核每一份推荐，并根据读者需求优先引进热门作品。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于韩漫平台，你关心的都在这里
        </p>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                <span>{faq.q}</span>
              </h3>
              <div className="flex items-start gap-3">
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-xs font-bold mt-0.5">
                  A
                </span>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}